import { trendInsights } from "@/mocks/manga";

export default function TrendsSection() {
  return (
    <section id="trends" className="w-full bg-foreground-950 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-xs font-label text-accent-300 uppercase tracking-widest">
            <i className="ri-line-chart-line text-base" aria-hidden="true"></i>
            Trends
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-background-50">
            榜单趋势解读：最近大家在追什么
          </h2>
          <p className="mt-3 text-sm md:text-base text-background-100/80 leading-relaxed">
            光看排名还不够——了解题材的冷热变化，能帮你判断一部作品是被持续看好，
            还是只是短暂冲高。以下是我们对近期榜单数据的观察。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {trendInsights.map((item) => (
            <article
              key={item.title}
              className="p-5 md:p-6 rounded-lg bg-background-50/5 border border-background-50/15"
            >
              <div className="flex items-center justify-between gap-4">
                <span className="w-10 h-10 rounded-md bg-accent-500/20 text-accent-300 flex items-center justify-center">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <div className="text-right">
                  <div className="font-heading text-xl md:text-2xl font-bold text-accent-300">
                    {item.metric}
                  </div>
                  <div className="text-xs font-label text-background-100/70">
                    {item.metricLabel}
                  </div>
                </div>
              </div>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-background-50">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-background-100/80 leading-relaxed">
                {item.text}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}